import React from "react";
import moment from "moment";
import { DbOrderItemInfos } from "../../../Core/Api/Types/db-order-item-infos";
import { orderService } from "../../../Core/Api/services";
import TableSkeleton from "../../../Components/Table/TableSkeleton";
import OrderItemTable, { OrderItemTableContext } from "../../../Components/Table/OrdersTable/orders-items-table";
import OrderItemPanel from "../../../Components/Panels/OrderItemPanel/order-item-panel";
import { useOutletContext } from "react-router";

function OrderItemQuoteDetails() {
  const [isLoading, setLoading] = React.useState(true);
  const [openPanelOrderItem, setOpenPanelOrderItem] = React.useState(false);
  const [selectedOrderItemId, setSelectedOrderItemId] = React.useState<number>(-1);
  const [rows, setData] = React.useState<DbOrderItemInfos[]>([]);

  // Outlet context used to pass props to parent DashboardLayout through react router dom
  const { selectedItems, setSelectedItems } = useOutletContext<{
    setSelectedItems: React.Dispatch<React.SetStateAction<DbOrderItemInfos[]>>;
    selectedItems: DbOrderItemInfos[];
  }>();

  const hidePanelOrder = () => {
    setOpenPanelOrderItem(false);
  };
  const showPanelOrder = (e: any) => {
    setSelectedOrderItemId(e);
    setOpenPanelOrderItem(true);
  };

  // Fetching data
  React.useEffect(() => {
    const start = moment().add(-30, "d").format("YYYY-MM-DD");
    const end = moment().add(1, "d").format("YYYY-MM-DD");

    orderService.GetItemsListQuoteByDate(start, end).then(function (response) {
      setData(response.items);
      setLoading(false);
    });
  }, []);

  return (
    <>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <OrderItemTable
          orders={rows}
          showPanelOrder={showPanelOrder}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          context={OrderItemTableContext.Quotes}
        />
      )}
      <OrderItemPanel open={openPanelOrderItem} onClose={hidePanelOrder} itemId={selectedOrderItemId} />
    </>
  );
}

export default OrderItemQuoteDetails;
